import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authRecovery',
	data () {
		return {
			countryCode: '',
			mobile: '',
			securityCode: '',
			isSubmitting: false
		}
	},
	mounted () {
		setTimeout(() => {
			this.focus()
		}, 10)
	},
	methods: {
		focus () {
			// $('#inputVerifyCode').focus()
		},
		onSubmit (e) {
			this.$validator.validateAll().then((result) => {
				if(result) {
					this.isSubmitting = true
					e.preventDefault()

					const data = {
						mobile: this.mobile,
						security_code: this.securityCode
					}

					api.recovery(data, (response) => {
						this.isSubmitting = false
						this.alertSuccessMessage(response)
					}, (e) => {
            this.isSubmitting = false
            // console.log(e)
						// this.handleErrorMessage(e)
						// console.log(e.status)
						this.alertErrorMessage(e, '#authRecovery')
					})
				}
			})
		}
	},
	watch: {
	}
})
